<template>
    <div class="heading">
        <div class="container py-5">
            <div class="row">
                <div class="col-md-12 text-left ">
                    <h1 class="ml-3">My Daily Workout</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Heading"
}
</script>

<style scoped>
h1::after {
    display: inline-block;
    content: "";
    border-top: .3rem solid #04D25A;
    width: 4rem;
    margin: 0 1rem;
    transform: translateY(-0.7rem);
}
</style>
